import { FC } from "react";
import { Box } from "@mui/material";
import CheckboxActiveSvg from "@/assets/svg/CheckboxActiveSvg";
import CheckboxInactiveSvg from "@/assets/svg/CheckboxInactiveSvg";

interface CustomCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  size?: number;
}

const CustomCheckbox: FC<CustomCheckboxProps> = ({ checked, onChange, size = 20 }) => {
  return (
    <Box
      sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
      onClick={(e) => {
        e.stopPropagation();
        onChange(!checked);
      }}
    >
      <Box
        sx={{
          width: size,
          height: size,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {checked ? <CheckboxActiveSvg size={size} /> : <CheckboxInactiveSvg size={size} />}
      </Box>
    </Box>
  );
};

export default CustomCheckbox;
